import { createContext, useContext } from "react";

export type FilterType = "tags";

export type FilterSettings = {
  type?: FilterType;
  tags: string[];
};

type FilterSettingsContext = FilterSettings & {
  setType: (type?: FilterType) => void;
  setTags: (tags: string[]) => void;

  reset: () => void;
};

export const FilterSettingsContext = createContext<FilterSettingsContext | undefined>(undefined);

export const useFilterSettings = (): FilterSettingsContext => {
  const context = useContext(FilterSettingsContext);

  if (!context) throw new Error(`Expected FilterSettingsContext in ancestor tree.`);

  return context;
};

FilterSettingsContext.displayName = "FilterSettingsContext";
